import { ScoreOverview } from "../../../types/scores";

export const normalizeOverviewRankingList = ( scores: ScoreOverview[] | null | undefined ) => {
  if (scores == null) return null;
  
  return scores.map((score) => ({
    id: score.brand_id,
    name: score.brand_name,
    value: score.ranking,
    logoUrl: score.logo_url,
  }))
    .filter((score) => score.value)
    .sort((a, b) => a.value - b.value)
    .slice(0, 5);
};